import { render, staticRenderFns } from "./NewsCreateModal.vue?vue&type=template&id=d69af8b6&scoped=true"
import script from "./NewsCreateModal.vue?vue&type=script&lang=js"
export * from "./NewsCreateModal.vue?vue&type=script&lang=js"
import style0 from "./NewsCreateModal.vue?vue&type=style&index=0&id=d69af8b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69af8b6",
  null
  
)

export default component.exports